'use strict';

(function ($) {

  var searchForm = $('.jc-search-form'),
      brandElement = searchForm.find('.brand');

  // Ao alterar marca
  brandElement.change(function () {

    var brand = $(this).val();
    var modelElement = $(this).closest('.jc-search-form').find('.model');

    if (brand) {
      getModels(modelElement, brand);
    } else {
      modelElement.find('option:not([value])').attr('selected', true);
      modelElement.attr('disabled', true);
    }
  });

  // Opções de Modelo
  function getModels(modelElement, brand) {
    modelElement.attr('disabled', false);
    modelElement.find('option:not([value])').attr('selected', true);
    modelElement.find('option[value]').hide();
    modelElement.find('[data-brand="' + brand + '"]').show();
  }

  // Clique de botão do componente, redireciona para pagina 0km com filtro aplicado
  searchForm.submit(function (event) {

    event.preventDefault();

    var form = $(this);
    var baseUrl = form.data('filter-url');

    var brand = form.find('.brand');
    var model = form.find('.model');

    var params = {
      marcas: brand.val(),
      modelos: model.val(),
      utm_content: form.data('utm-content')
    };

    $.each(params, function (index, value) {
      if (value === "" || value === null || value === [] || value === 'Marca' || value == 'Modelo') {
        delete params[index];
      }
    });

    var urlQuery = $.param(params, true);
    if (urlQuery) {
      baseUrl += '?' + urlQuery;
    }

    window.location.href = baseUrl;
  });
})(jQuery);